import React from 'react';
import { Button, Form, Grid, Popup, Responsive, Tab, Table } from 'semantic-ui-react';
import axios from 'axios';
import StudentGrades from './StudentGrades';
import NextSemesterEnroll, {
    fetchCurrentSemestersDropdown,
    fetchStudentStatuses,
    fetchStudentStatusesLookup
} from './NextSemesterEnroll';
import StudentPauseStatus from './StudentPauseStatus';
import DisciplinaryMeasuresStatus from './DisciplinaryMeasuresStatus';
import { fetchCurrentStudyProgramInfo } from '../../StudentPersonalInfo/request';
import CurrentStudyTable from '../../StudentPersonalInfo/CurrentStudyTable';
import StudyProgramWithdrawal from '../FilterStudents/StudyProgramWithdrawal';
import CourseEnroll from './CourseEnroll';
import NotPassedCourses from './NotPassedCourses';
import { toast, ToastContainer } from 'react-toastify';
import RegisteredExamsByTerm from './RegisteredExamsByTerm';
import InputGradesAdminPanel from '../../Admin/Students/InputGrades/InputGradesAdminPanel';
import ExamRegistrationAdminPanel from '../../Admin/Students/ExamRegistration/ExamRegistrationAdminPanel';
import StudentRole from './StudentRole';
import CourseEnrollmentAdminPanel from '../../Admin/Students/CourseEnrollment/CourseEnrollmentAdminPanel';
import StudentInternships from './StudentInternships';
import { fetchAcademicYears, fetchStudyType } from '../../Lookups/util';

export const fetchStudentSemesters = (studentStudyProgramId) => axios.get(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support'
    ? `students/${studentStudyProgramId}/semesters/overview-for-admin/` : `students/${studentStudyProgramId}/semesters/overview/`);

export default class StudentOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyPrograms: [],
            currentStudyProgramInfo: {},
            faculties: [],
            departments: [],
            validIndexes: [],
            allIndexes: [],
            invalidIndexes: [],
            editMode: false,
            newNumber: '',
            thirdCycle: false,
            gapYear: false
        };

        this.getIndex = this.getIndex.bind(this);
        this.editIndex = this.editIndex.bind(this);
        this.removeIndex = this.removeIndex.bind(this);
        this.checkThirdCycle = this.checkThirdCycle.bind(this);
        this.addIndex = this.addIndex.bind(this);
        this.getCurrentStudyProgramInfo = this.getCurrentStudyProgramInfo.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.setActiveIndex = this.setActiveIndex.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('thirdCycle');
        this.getIndex();
        this.checkThirdCycle(this.props.student.id);
        this.getCurrentStudyProgramInfo();

        axios.all([fetchStudentSemesters(this.props.student.id)])
            .then(axios.spread((res) => {
                if (res.data[0] && res.data[0].studentStatus._key === 'gap_year') this.setState({ gapYear: true });
            }));
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    setActiveIndex(index) {
        this.setState({ activeIndex: index });
    }

    getCurrentStudyProgramInfo() {
        this.setState({ currentStudyProgramInfoLoader: true });
        fetchCurrentStudyProgramInfo('Studentska', this.props.student.studentId, this.props.student.studyProgramId)
            .then(currentStudyProgramInfo => {
                this.setState({
                    currentStudyProgramInfoLoader: false,
                    currentStudyProgramInfo: {
                        ...currentStudyProgramInfo,
                        archived: currentStudyProgramInfo.studyProgramStatus ? currentStudyProgramInfo.studyProgramStatus.name._key === 'archived' ? 'true' : 'false' : null
                    },
                    faculties: currentStudyProgramInfo.faculties,
                    departments: currentStudyProgramInfo.department,

                });

                if (currentStudyProgramInfo.gradStudentAcademicYear) {
                    localStorage.setItem('apsolvent', currentStudyProgramInfo.gradStudentAcademicYear.name);
                }
            });
    }

    checkThirdCycle(studentStudyProgramId) {
        axios.get(`/students/third-cycle-or-specialist-sp-check/${studentStudyProgramId}/`)
            .then(res => {
                if (res.data) {
                    this.setState({
                        thirdCycle: true
                    });
                    localStorage.setItem('thirdCycle', '1');
                }
            });
    }

    getIndex() {
        axios.get(`students/get-identification-document/${this.props.student.id}`)
            .then(res => {
                this.setState({ validIndexes: res.data.filter(el => el.valid === true), allIndexes: res.data, invalidIndexes: res.data.filter(el => el.valid === false) });
            })
            .catch(err => { console.log('Failed to fetch index.'); });
    }

    editIndex(optLock, id) {
        let obj = {
            number: this.state.newNumber,
            id,
            optLock
        };
        axios.put('students/edit-identification-document', { ...obj })
            .then(res => {
                toast('Izmjena indexa je uspješno izvršena.');
                this.setState({ editMode: false });
                this.getIndex();
            })
            .catch(err => {
                console.log('Failed to fetch index.');
                toast('Došlo je do greške! Izmjena indexa nije izvršena.');
            });
    }

    addIndex(optLock, oldId) {
        let obj = {
            number: this.state.newNumber,
            studentStudyProgram: {
                id: this.props.student.id
            }

        };
        axios.post(`students/archive-old-identification-document/${oldId}`, { ...obj })
            .then(res => {
                toast('Uspješno ste dodali novi index. Prethodni je arhiviran.');
                this.setState({ addMode: false });
                this.getIndex();
            })
            .catch(err => {
                toast('Došlo je do greške! Dodavanje indexa nije izvršeno.');
            });
    }

    removeIndex(id) {
        let obj = { id };
        axios.put('students/identification-document-not-valid-anymore', { ...obj })
            .then(res => {
                toast('Index je uspješno uklonjen.');
                this.setState({ confirmation: false });
                this.getIndex();
            })
            .catch(err => {
                console.log('Failed to fetch index.');
                toast('Došlo je do greške! Index nije uklonjen.');
            });
    }

    render() {
        const { student } = this.props;

        const panes = [
            {
                menuItem: 'Trenutni studij',
                render: () => (<Tab.Pane attached={false} as={Responsive} >
                    <div>
                        {!this.props.limitation && <Table celled compact size="small" structured>
                            <Table.Body>

                                {this.state.validIndexes.map((el, index) =>
                                    (<Table.Row key={index}>
                                        {index === 0 && <Table.Cell rowSpan={this.state.validIndexes.length} textAlign="right" verticalAlign="middle"><b>Index</b></Table.Cell>}
                                        <Table.Cell verticalAlign="middle" textAlign="left">
                                            <Grid>
                                                <Grid.Column width={8} verticalAlign="middle" >
                                                    {(this.state.editMode === index || this.state.addMode === index) ?
                                                        <Form size="mini">
                                                            <Form.Field >
                                                                <input
                                                                    placeholder="Unesite broj indexa"
                                                                    value={this.state.newNumber}
                                                                    onChange={(e) => this.setState({ newNumber: e.target.value })}
                                                                    name="input"
                                                                />
                                                            </Form.Field>
                                                            {this.state.addMode === index && <p></p>}
                                                        </Form>
                                                        : el.number
                                                    }
                                                </Grid.Column>
                                                <Grid.Column width={8} textAlign="right">
                                                    {this.state.confirmation === index ?
                                                        <div style={{ float: 'right' }}>
                                                            <h5>Jeste li sigurni?</h5>
                                                            <Button.Group compact size="small">
                                                                <Button
                                                                    basic="true"
                                                                    color="blue"
                                                                    onClick={() => this.removeIndex(el.id)}
                                                                > DA
                                                                </Button>
                                                                <Button
                                                                    basic="true"
                                                                    color="red"
                                                                    onClick={() => { this.setState({ confirmation: false }); }}
                                                                >  NE
                                                                </Button>
                                                            </Button.Group></div>
                                                        : (this.state.editMode === index || this.state.addMode === index) ? <div>


                                                            <Popup
                                                                size="tiny"
                                                                trigger={<Button
                                                                    size="mini"
                                                                    basic="true"
                                                                    color="blue"
                                                                    onClick={() => {
                                                                        if (this.state.editMode === index) this.editIndex(el.optLock, el.id);
                                                                        if (this.state.addMode === index) this.addIndex(el.optLock, el.id);
                                                                    }}
                                                                >
                                                                    {this.state.editMode === index ? 'Sačuvaj' : 'Dodaj'}
                                                                </Button>}
                                                                content={this.state.editMode === index ? 'Sačuvaj izmjene' : 'Dodavanjem novog indexa stari se arhivira.'}
                                                                hideOnScroll
                                                                position="top right"
                                                            />

                                                            <Button
                                                                size="mini"
                                                                basic="true"
                                                                color="red"
                                                                onClick={() => this.setState({ editMode: false, addMode: false })}
                                                            >Odustani</Button>

                                                        </div>
                                                            : <div>
                                                                <Popup
                                                                    size="tiny"
                                                                    trigger={<Button
                                                                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                                        basic="true"
                                                                        circular
                                                                        color="blue"
                                                                        icon="add"
                                                                        size="mini"
                                                                        onClick={() => this.setState({ addMode: index, newNumber: null })}
                                                                    />}
                                                                    content="Dodaj novi index"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />
                                                                <Popup
                                                                    size="tiny"
                                                                    trigger={<Button
                                                                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                                        basic="true"
                                                                        circular
                                                                        color="green"
                                                                        icon="pencil"
                                                                        size="mini"
                                                                        onClick={() => this.setState({ editMode: index, newNumber: el.number })}
                                                                    />}
                                                                    content="Izmijeni index"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />

                                                                { this.state.validIndexes.length > 1 &&
                                                                <Popup
                                                                    size="tiny"
                                                                    trigger={<Button
                                                                        basic="true"
                                                                        circular
                                                                        icon="archive"
                                                                        size="mini"
                                                                        color="red"
                                                                        onClick={() => this.setState({ confirmation: index })}
                                                                    />}
                                                                    content="Arhiviraj index"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />
                                                                }
                                                                <Popup
                                                                    size="tiny"
                                                                    trigger={<Button
                                                                        disabled={this.state.invalidIndexes.length === 0 || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                                        basic="true"
                                                                        circular
                                                                        color="orange"
                                                                        icon={this.state.showInvalidIndexes ? 'chevron up' : 'chevron down'}
                                                                        size="mini"
                                                                        onClick={() => this.setState({ showInvalidIndexes: !this.state.showInvalidIndexes })}
                                                                    />}
                                                                    content="Prikaži arhivirane indexe"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />

                                                            </div>}
                                                </Grid.Column>
                                            </Grid>
                                        </Table.Cell>
                                    </Table.Row>))}
                                {this.state.showInvalidIndexes && this.state.invalidIndexes.map((el, index) =>
                                    (<Table.Row key={index}>
                                        {index === 0 && <Table.Cell rowSpan={this.state.invalidIndexes.length} textAlign="right" verticalAlign="middle"><b>Arhivirani indexi</b></Table.Cell>}
                                        <Table.Cell negative verticalAlign="middle" textAlign="left">
                                            {el.number}
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>
                        </Table>}
                    </div>

                    <CurrentStudyTable
                        currentEducation
                        currentStudyProgramInfo={this.state.currentStudyProgramInfo}
                        getCurrentStudyProgramInfo={this.getCurrentStudyProgramInfo}
                        currentStudyProgramInfoLoader={this.state.currentStudyProgramInfoLoader}
                        faculties={this.state.faculties}
                        departments={this.state.departments}
                        noIndex={!this.props.limitation}
                        studentId={this.props.student.studentId}
                        studyProgramId={this.props.student.studyProgramId}
                        limitation={this.props.limitation}
                        locked={this.props.locked}
                    />
                </Tab.Pane>)
            },


            localStorage.getItem('activeRole') !== 'Support' && {
                menuItem: 'Ocjene',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentGrades
                        studentId={student.id}
                        thirdCycle={this.state.thirdCycle}
                    />
                </Tab.Pane>)
            },
            ((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && !this.props.locked) && {
                menuItem: 'Unos ocjena',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <InputGradesAdminPanel
                        hideHeader
                        hideSegments
                        redirectType="inputGrades"
                        studentId={student.id}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Semestri',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <NextSemesterEnroll
                        studentStudyProgramId={student.id}
                        limitation={this.props.limitation}
                        gradStudentAcademicYear={(this.state.currentStudyProgramInfo && this.state.currentStudyProgramInfo.gradStudentAcademicYear) ? this.state.currentStudyProgramInfo.gradStudentAcademicYear.id : null}
                        thirdCycle={this.state.thirdCycle}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Ispiti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <RegisteredExamsByTerm
                        studentStudyProgramId={student.id}
                    />
                </Tab.Pane>)
            },
            ((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && !this.props.locked) && {
                menuItem: 'Prijava ispita',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <ExamRegistrationAdminPanel
                        hideHeader
                        hideSegments
                        redirectType="examRegistration"
                        studentId={student.id}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Praksa',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentInternships
                        studentStudyProgramId={student.id}
                        locked={this.props.limitation}
                        pauseSemester={this.props.pauseSemester}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Nepoloženi predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <NotPassedCourses
                        studentStudyProgramId={student.id}
                        limitation={this.props.limitation}
                        gradStudentAcademicYear={(this.state.currentStudyProgramInfo && this.state.currentStudyProgramInfo.gradStudentAcademicYear) ? this.state.currentStudyProgramInfo.gradStudentAcademicYear.id : null}
                    />
                </Tab.Pane>)
            },
            !this.props.limitation && !this.state.thirdCycle && localStorage.getItem('activeRole') !== 'AIDA' && localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && {
                menuItem: 'Upis na predmet',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <CourseEnroll
                        gapYear={this.state.gapYear}
                        studentStudyProgramId={student.id}
                    />
                </Tab.Pane>)
            },
            ((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && !this.props.locked) && {
                menuItem: 'Upis na predmet',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <CourseEnrollmentAdminPanel
                        currentEdu={localStorage.setItem('currentEducation', true)}
                    ></CourseEnrollmentAdminPanel>
                </Tab.Pane>)
            },
            localStorage.getItem('activeRole') !== 'Support' && {
                menuItem: 'Statusi mirovanja',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentPauseStatus
                        studentStudyProgramId={student.id}
                        locked={this.props.limitation}
                        pauseSemester={this.props.pauseSemester}
                        updateStudentStatuses={this.props.updateStudentStatuses}
                        togglePauseVisibility={this.props.togglePauseVisibility}
                    />
                </Tab.Pane>)
            },
            localStorage.getItem('activeRole') !== 'Support' && {
                menuItem: 'Disciplinske mjere',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <DisciplinaryMeasuresStatus
                        studentId={student.studentId}
                        studentStudyProgramId={student.id}
                        studyProgramId={student.studyProgramId}
                        disciplinaryMeasure={this.props.disciplinaryMeasure}
                        limitation={this.props.limitation}
                        updateStudentStatuses={this.props.updateStudentStatuses}
                        toggleDisciplinaryVisibility={this.props.toggleDisciplinaryVisibility}
                    />
                </Tab.Pane>)
            },

            ((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') && (!this.props.limitation && !this.props.graduationDate)) ? {
                menuItem: 'Uloge studenta',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentRole
                        studentId={student.studentId}// personId
                        studentStudyProgramId={student.id}
                        studyProgramId={student.studyProgramId}
                        limitation={this.state.locked || this.state.studyProgramStudentSwitchedToId}
                    />
                </Tab.Pane>)
            } : null,
            // !this.props.limitation && {
            //     menuItem: 'Upis na studijski program',
            //     render: () => (<Tab.Pane attached={false} as={Responsive} >
            //
            //         <StudyPrograms
            //             studentId={student.studentId}
            //             student={student.firstName + ' ' + student.lastName}
            //             studentInfo
            //         />
            //     </Tab.Pane>)
            // },
            (this.props.pauseSemester || !this.props.limitation) && !this.props.graduationDate && localStorage.getItem('activeRole') !== 'Support' && {
                menuItem: 'Ispis studenta',
                render: () => (<Tab.Pane attached={false} as={Responsive} >
                    <br />
                    <StudyProgramWithdrawal
                        updateStudentStatuses={this.props.updateStudentStatuses}
                        studentStudyProgramId={student.id}
                        toggleAbandonmentVisibility={this.props.toggleAbandonmentVisibility}
                        getCurrentStudyProgramInfo={this.getCurrentStudyProgramInfo}
                        jmbg={this.props.jmbg}
                        student={this.props.student}
                        setActiveIndex={this.setActiveIndex}
                    />

                </Tab.Pane>)
            }
        ];
        return (<div>
            <Tab
                panes={panes}
                menu={{
                    secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                }}
                grid={{ paneWidth: 13, tabWidth: 3 }}
                activeIndex={this.state.activeIndex ? this.state.activeIndex : 0}
                onTabChange={this.handleTabChange}
            />
            <ToastContainer hideProgressBar />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/CurrentEducation.js